
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading, { type StateChanger } from 'vue-infinite-loading'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { EnumLoadResult } from '@xt/client/utils/infinite-loading/index'
import { Observer } from 'mobx-vue'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import lodash from 'lodash'
import { autorun } from 'mobx'

@Observer
@Component({
  components: { EmptyStatus, InfiniteLoading }
})
export default class InfiniteLoadingV2 extends Vue {
  @Prop() identifier
  @Prop() pagePagination: PagePagination<any>
  @Prop() body: Record<string, unknown>

  // storeIdentifier追踪函数，组件销毁时清理
  disposer: () => void
  // 调用pagePagination.clearData时能有效刷新列表，等价于$state.reset()
  storeIdentifier: string = ''

  get hasNoResults() {
    return lodash.has(this.$slots, 'no-results')
  }

  get hasSpinner() {
    return lodash.has(this.$slots, 'spinner')
  }

  get hasNoNmore() {
    return lodash.has(this.$slots, 'no-more')
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  async infiniteHandler($state: StateChanger) {
    const res = await this.pagePagination.loadData({
      ...this.body
    })

    console.log('infiniteHandler', res)

    if (res === EnumLoadResult.Cancel) {
      console.log('其他异常')
    }

    if (res === EnumLoadResult.Error) {
      $state.error()
    }

    if (res === EnumLoadResult.Loaded) {
      $state.loaded()
    }

    if (res === EnumLoadResult.Complete) {
      if (this.pagePagination.dataSource.length > 0) {
        $state.loaded()
      }
      $state.complete()
    }
  }

  init() {
    // 此处的identifier全部由pagePagination管理，对于多tabs页的情况在业务部分调用pagePagination的clearData时即可刷新列表。
    if (this.identifier) {
      this.storeIdentifier = this.identifier
      this.pagePagination.compReset(this.identifier)
    }

    this.disposer = autorun(() => {
      this.storeIdentifier = this.pagePagination.identifier
    })
  }

  created(): void {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    // 无限滚动列表 销毁时 清理
    this.pagePagination.reset()
    this.disposer()
  }
}
